import { takeLatest, put, call } from 'redux-saga/effects';
import { axiosInstance } from '../../utils';

import { SHARE_WITH_FRIEND_REQUEST, SHARE_WITH_FRIEND_SUCCESS, SHARE_WITH_FRIEND_FAILURE } from "../types";

function* shareWithFriendSaga({ payload }) {
  const { email, bookingId } = payload;

  try {
    yield call(axiosInstance.post, `booking/${bookingId}/share`, { email });
    yield put({ type: SHARE_WITH_FRIEND_SUCCESS });
  } catch (error) {
    yield put({ type: SHARE_WITH_FRIEND_FAILURE, payload: 'Something went wrong' });
  }
}

export default function* saga() {
  yield takeLatest(SHARE_WITH_FRIEND_REQUEST, shareWithFriendSaga);
}
